import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import styles from './index.css';

export interface IZoomControlsProps {
  onZoomIn(): void;
  onZoomOut(): void;
  centred?: boolean;
  disabledZoomIn: boolean;
  disabledZoomOut: boolean;
}

export class ZoomControls extends React.Component<IZoomControlsProps, {}> {
  public render() {
    const { onZoomIn, onZoomOut, centred, disabledZoomIn, disabledZoomOut } = this.props;

    return (
      <div {...mergeStyles(styles['container'], centred && styles['centred'])}>
        <div
          {...mergeStyles(styles['in'], disabledZoomIn && styles['disabled'])}
          onClick={() => {
            if (!disabledZoomIn) {
              onZoomIn();
            }
          }}
        />
        <div
          {...mergeStyles(styles['out'], disabledZoomOut && styles['disabled'])}
          onClick={() => {
            if (!disabledZoomOut) {
              onZoomOut();
            }
          }}
        />
      </div>
    );
  }
}
